export enum ASubheaderSize {
  XL = 'XL',
  L = 'L',
  M = 'M',
  S = 'S',
}

export enum ASubheaderTag {
  h2 = 'h2',
  h3 = 'h3',
  h4 = 'h4',
  h5 = 'h5',
  h6 = 'h6',
}

export interface ASubheaderProps extends React.HTMLAttributes<HTMLHeadingElement> {
  text: string;
  size?: ASubheaderSize;
  element?: ASubheaderTag;
}